<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part">
<h2 class="centred firstInSection">Part One</h2>
<h3 class="centred"><em>Australia 1870</em></h3>
<h3 class="centred">Ambitious Dreams</h3>
<blockquote class="hanging_indent bq">
<p class=" firstInSection">When night moves in</p>
<p>To hide the sun,</p>
<p>When enemies rally</p>
<p>And your strength is done,</p>
<p>When your weary heart</p>
<p>Longs to be free,</p>
<p>Think of me, beloved,</p>
<p>Think of me.</p>
</blockquote>
<p class="source_right">J.C.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?77540c01